import React from "react";
import ExtraInputComponent from "./ExtraInputComponent";
import ParametersInputComponent from "./ParametersInputComponent";

function OtherExerciseFields({
  parameters,
  freeFormSelected,
  updateOtherExerciseParameters,
  videoUrl,
  videoFile,
  videoOriginal, // if there is an uploaded video
  exerciseTypeField,
  primaryMuscleGroup,
  secondaryMuscleGroup,
  instructions,
  handleInputChange,
  cleanVideoField,
  className,
  form,
  intensityMeasure,
  isRiR,
}) {
  return (
    <>
      <ParametersInputComponent
        parameters={parameters}
        freeFormSelected={freeFormSelected}
        updateOtherExerciseParameters={updateOtherExerciseParameters}
        className={className}
        form={form || ""}
        intensityMeasure={intensityMeasure}
        isRiR={isRiR}
      />

      <ExtraInputComponent
        videoUrl={videoUrl}
        videoFile={videoFile}
        videoOriginal={videoOriginal}
        exerciseTypeField={exerciseTypeField}
        primaryMuscleGroup={primaryMuscleGroup}
        secondaryMuscleGroup={secondaryMuscleGroup}
        instructions={instructions}
        handleInputChange={handleInputChange}
        cleanVideoField={cleanVideoField}
        className={className}
        form={form}
      />
    </>
  );
}

export default OtherExerciseFields;
